module.exports = __webpack_public_path__ + "img/icon_dean_home_card_empty_icon_2.2188a2a7.png";